import { Typography } from 'components/ui/Typography'
import styled, { css } from 'styled-components'

export const ContentWrapper = styled.div`
  max-width: 920px;
  span {
    line-height: 1.5;
  }

  a {
    color: ${({ theme }) => theme.palette.core.BLUE};
    transition: all 0.2s ease;
    &:hover {
      color: ${({ theme }) => theme.palette.secondary.MAIN};
    }
  }
`

export const FloatedTypography = styled(Typography)<{ dots?: boolean }>`
  float: left;
  line-height: ${({ dots }) => (dots ? '1 !important' : 1.5)};
  height: 19px;
`

export const Paragraph = styled.div<{ level?: 'first' | 'second' }>`
  ${({ level = 'first' }) => {
    if (level === 'first')
      return css`
        margin: 16px 0;
        @media screen and (max-width: 768px) {
          margin: 24px 0 8px;
        }
      `

    return css`
      margin: 16px 0;
      @media screen and (max-width: 768px) {
        margin: 8px 0;
      }
    `
  }}
`
